import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { initialStateSlice } from "../../initialStateSlice";
import { fetcher } from "../../../apis";

const organizationSettingsSlice = createSlice({
  name: "organizationSettings",
  initialState: initialStateSlice,
  reducers: {
    set_organizationSettings: (state, action) => {
      return action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(load_organizationSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(load_organizationSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.body = action.payload;
      })
      .addCase(load_organizationSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      })
      .addCase(update_organizationSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(update_organizationSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.body = action.payload;
      })
      .addCase(update_organizationSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
  },
});

export const { set_organizationSettings } = organizationSettingsSlice.actions;
export default organizationSettingsSlice;

export const load_organizationSettings = createAsyncThunk(
  "reference/organizationSettings/load_organizationSettings",
  async (payload, { getState, dispatch }) => {
    const result = await fetcher({
      route: "organizationSettings/organization",
    });
    if (result.ok) {
      return result.json.data;
    } else {
      throw result.json.message;
    }
  }
);

export const update_organizationSettings = createAsyncThunk(
  "reference/organizationSettings/update_organizationSettings",
  async (payload, { getState, dispatch }) => {
    const result = await fetcher({
      route: "/organizationSettings/organization",
      method: "PUT",
      body: payload,
    });
    if (result.ok) {
      const resOrg = await fetcher({
        route: "/organizationSettings/organization",
      });
      if (resOrg.ok) {
        return resOrg.json.data;
      } else {
        throw resOrg.json.message;
      }
    } else {
      throw result.json.message;
    }
  }
);
